import axios from "axios";
import Swal from "sweetalert2";
// import Multiselect from "@vueform/multiselect";
//import MMultiselect from "multi-select-master";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
//Object.defineProperty(this.prototype, '$mms', { value: mms });
export default {
  name: "visitType",
  // components: {
  //   Multiselect,
  //   //  MMultiselect,
  // },
  data() {
    return {
      //task
      taskSelected: [],
      taskOptions: [],
      //for VisitReason
      dataChanged: false,
      resCount: 0,
      count: 0,
      nDelete: 0,
      visitData: {
        isDeleted: "",
      },
      TimerObjectTable: {},
      tableLoaderDemo: false,
      tableLoaderQuest: false,
      VisitTypeActiveIndex: -1,
      //template List
      checked: true,
      smsList1: [],
      emailList1: [],
      display1: false,
      display2: false,
      display3: false,
      display4: false,
      display5: false,

      Active1: true,

      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
      displayThisComponent: false,
      loader: "",
      //Timer
      TimerObject: {},
      smsSelected: [],
      smsList: ["Batman", "Robin", "Joker"],
      emailSelected: [],
      emailList: ["Superman", "Louis Lane", "Daily Planet"],
      selectedQuests: [],
      selectedDemos: [],
      physicianId: -1,
      visitTypeIndex: -1,
      reasonIndex: -1,
      visitType: {
        isActive: 1,
        isDeleted: 0,
        name: "",
        practiceId: 0,
        srNo: 0,
        visitTypeId: 0,
        visitDetail: [
          {
            visitQuestDemo: [{}],
            visitSmsEmail: [{}],
          },
        ],
      },
      lastErrorCode: "",
      visitTypeList: "",
      singleVTL: "",
      vtlName: "",
      reasonName: "",
      quests_2: [], // used to hold the selected questions
      demos_2: [],
      quests: "",
      demos: "",
      emails: "",
      smss: "",
      phys: "",
      ddd: "",
      dummy009: [],
      mydata: "",
      visitDetailId: "",
      selectedQuestIds: [],
      visitTypeDetailSrno:[],
      //DataTable Default Variables
      pageSize: 50,
      pageSizeDemo: 50,
      pageNumber: 1,
      pageNumberDemo: 1,
      totalPages: 0,
      totalPagesDemo: 0,
      filter: "",
      filterDemo: "",
      totalRows: 0,
      totalRowsQcount: 0,

      activeVisitReason: {},
      totalRowsDemo: 0,
      totalRowsDcount: 0,
      orderByCol: 1, // if orderby number is same do opposite
      asc_desc: "asc", //remember what asv and desc
      remeberOrder: "",
      firstTime: true,
      DataTable: {},
      //==========================
      //==========================
    };
  }, // data
  methods: {
    getChanges(q) {
      // //debugger;
      if (
        q.demoName == "First Name" ||
        q.demoName == "LastName" ||
        q.demoName == "DOB" ||
        q.demoName == "Gender"
        //||
        //   q.demoName == ' External ID' || q.demoName == 'SSN' || q.demoName == 'Phone' ||
        //   q.demoName == 'Email' || q.demoName == 'Street' || q.demoName == 'City' ||
        //   q.demoName == 'State' || q.demoName == 'Zip' || q.demoName == 'Primary Insurance Name' ||
        //   q.demoName == 'Primary Insurance Number' || q.demoName == 'Primary Insurance Group Name' ||
        //   q.demoName == 'Primary Insurance Image Upload' || q.demoName == 'Secondary Insurance Name' ||
        //   q.demoName == 'Secondary Insurance Number' || q.demoName == 'Secondary Insurance Group Name' ||
        //   q.demoName == 'Secondary Insurance Image upload'
      ) {
        return true;
      } else {
        return false;
      }
    },

    //Timer
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    closeBasic() {
      this.display1 = false;
    },

    closeBasic1() {
      this.display3 = false;
    },
    closeBasic11() {
      this.display4 = false;
    },
    closeBasicActive() {
      this.display5 = false;
    },
    QuestionaireActiveChange(questId, requiredId, quest) {
      //debugger;
      this.dataChanged = true;
      // usman quest
      var count = 0;
      for (let i = 0; i < this.selectedQuests.length; i++) {
        if (this.selectedQuests[i].questId == questId) {
          if (requiredId) {
            this.selectedQuests[i].isRequired = true;
            count++;
          } else {
            this.selectedQuests[i].isRequired = false;
            count++;
          }
          break;
        }
      }
      if (count == 0) {
        quest.isRequired = false;
      }
    },
    async axiosGetProfileData111(Url, objt) {
      // var loader = this.$loading.show({
      //   // Optional parameters
      //   color: "#03a9f3",
      // });
      console.log("PostData");
      await axios({
        method: "post",
        url: Url,
        data: objt,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // loader.hide();
          const result = res.data;
          if (result.status) {
            console.log("ok");
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          this.ResetLogoutTime();
          // loader.hide();
        });
    },

    DemoActiveChange(questId, requiredId, demo) {
      //debugger;
      this.dataChanged = true;
      var count = 0;
      for (let i = 0; i < this.selectedDemos.length; i++) {
        if (
          this.selectedDemos[i].questId == questId &&
          this.selectedDemos[i].visitDetailId == this.visitDetailId
        ) {
          if (requiredId) {
            this.selectedDemos[i].isRequired = true;
            count++;
          } else {
            this.selectedDemos[i].isRequired = false;
            count++;
          }
          break;
        }
      }
      if (count == 0) {
        demo.isRequired = false;
      }
    },
    async axiosGetProfileData11(Url, objt) {
      // var loader = this.$loading.show({
      //   // Optional parameters
      //   color: "#03a9f3",
      // });
      console.log("PostData");
      await axios({
        method: "post",
        url: Url,
        data: objt,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // loader.hide();
          const result = res.data;
          if (result.status) {
            console.log("ok");
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          this.ResetLogoutTime();
          // loader.hide();
        });
    },

    handleRole() {
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        this.val = this.EmployeeRolesStr.filter((i) => i.name == "Visit Type");
        if (this.val[0].canUpdate == 0) {
          this.updButton = 0;
        }
        if (this.val[0].canDelete == 0) {
          this.delButton = 0;
        }
        if (this.val[0].canCreate == 0) {
          $("button[name=vType]").hide();
        }
      }
    },

    ArchiveShow1(id, ndx) {
      this.display4 = true;
      this.arcId1 = id;
      this.arcndx1 = ndx;
    },

    ActiveShow(id, ndx) {
      this.display5 = true;
      this.arcId11 = id;
      this.arcndx11 = ndx;
    },

    deleteVisitTypeClick(id, ndx) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Remove",
      }).then((result) => {
        //debugger;
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = id + this.UKEY;
          this.visitTypeIndex = ndx;
          const url = this.SERVER + "/VNSPRAAPI/Reasons/DLVT";
          this.axiosGetData(url, 3, this.dummyComm);
        }
      });
    },
    ArchiveShow(id, ndx) {
      console.log(id, ndx);
      this.display3 = true;
      this.arcId = id;
      this.arcndx = ndx;
    },
    deleteVisitTypeClick_1() {
      this.intDummyComm();
      this.dummyComm.extras = this.arcId + this.UKEY;
      this.visitTypeIndex = this.arcndx;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/DLVT";
      this.axiosGetData(url, 4, this.dummyComm);
      this.displayThisComponent = false;
      this.display3 = false;
    },
    async mainDownArrowClick(ndx, visitType) {
      debugger;
      if (ndx < this.visitTypeList.vtftl.length - 1) {
        var PreviousNumber = visitType.vt.srNo;
        var NewNumber = visitType.vt.srNo + 1;
        [this.visitTypeList.vtftl[ndx + 1], this.visitTypeList.vtftl[ndx]] = [
          this.visitTypeList.vtftl[ndx],
          this.visitTypeList.vtftl[ndx + 1],
        ];
        for (let i = 0; i < this.visitTypeList.vtftl.length; i++)
          this.visitTypeList.vtftl[i].vt.srNo = i + 1;
        this.intDummyComm();
        let myData = {
          dc: this.dummyComm,
          previousNumber: PreviousNumber,
          NewNumber: NewNumber,
          visitTypeId: visitType.vt.visitTypeId,
          vtftl: this.visitTypeList.vtftl,
        };
        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
       await  axios({
          method: "post",
          url: this.SERVER + "/VNSPRAAPI/Reasons/UpdateVisitTypeSerialNo",
          data: myData,
              headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
        })
          .then((res) => {
            loader.hide();
            this.dummyComm = res.data;
            if (this.dummyComm.auditFlag <= 0) {
              alert("Unable to update");
              [
                this.visitTypeList.vtftl[ndx + 1],
                this.visitTypeList.vtftl[ndx],
              ] = [
                this.visitTypeList.vtftl[ndx],
                this.visitTypeList.vtftl[ndx + 1],
              ];
              for (let i = 0; i < this.visitTypeList.vtftl.length; i++)
                this.visitTypeList.vtftl[i].vt.srNo = i + 1;
            }
            // else {
            //   alert("Updated successfully...");
            // }
          })
          .catch(function(error) {
            if (error.response) {
              alert("-> " + error.response.data);
              alert("-> " + error.response.status);
              alert("-> " + error.response.headers);
            } else if (error.request) {
              alert("No response " + error.request);
            }
          })
          .finally(() => {
            this.ResetLogoutTime();
            loader.hide();
          });
      }
    },
   async mainUpArrowClick(ndx, visitType) {
     debugger

      if (ndx > 0) {
        var PreviousNumber = visitType.vt.srNo;
        var NewNumber = visitType.vt.srNo - 1;
        [this.visitTypeList.vtftl[ndx - 1], this.visitTypeList.vtftl[ndx]] = [
          this.visitTypeList.vtftl[ndx],
          this.visitTypeList.vtftl[ndx - 1],
        ];
        for (let i = 0; i < this.visitTypeList.vtftl.length; i++)
          this.visitTypeList.vtftl[i].vt.srNo = i + 1;
        this.intDummyComm();
        let myData = {
          dc: this.dummyComm,
          previousNumber: PreviousNumber,
          newNumber: NewNumber,
          visitTypeId: visitType.vt.visitTypeId,
          vtftl: this.visitTypeList.vtftl,
        };
        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
       await  axios({
          method: "post",
          url: this.SERVER + "/VNSPRAAPI/Reasons/UpdateVisitTypeSerialNo",
          data: myData,
           headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
        })
          .then((res) => {
            loader.hide();
            this.dummyComm = res.data;
            if (this.dummyComm.auditFlag <= 0) {
              alert("Unable to update");
              [
                this.visitTypeList.vtftl[ndx - 1],
                this.visitTypeList.vtftl[ndx],
              ] = [
                this.visitTypeList.vtftl[ndx],
                this.visitTypeList.vtftl[ndx - 1],
              ];
              for (let i = 0; i < this.visitTypeList.vtftl.length; i++)
                this.visitTypeList.vtftl[i].vt.srNo = i + 1;
            }
            // else {
            //   alert("Updated successfully...");
            // }
          })
          .catch(function(error) {
            if (error.response) {
              alert("-> " + error.response.data);
              alert("-> " + error.response.status);
              alert("-> " + error.response.headers);
            } else if (error.request) {
              alert("No response " + error.request);
            }
          })
          .finally(() => {
            this.ResetLogoutTime();
            loader.hide();
          });
      }
    },
    addNewStage() {
      //debugger;
      $("#addNewStg_btn").prop("disabled", true);
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.extras1 = "";
      const url = this.SERVER + "/VNSPRAAPI/Reasons/AddNewVisitTypeReason";
      this.dummyComm.pageNumber = this.pageNumberDemo;
      this.dummyComm.pageSize = this.pageSizeDemo;
      this.dummyComm.filter = this.filterDemo;

      var obj = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        filter: this.filter,
        dc: this.dummyComm,
      };
      this.axiosGetData(url, 1, obj).then(() => {
        window.scrollTo(0, document.body.scrollHeight);
      });
    },

    // demoDeselectAllClick() {
    //   $("#demoControl").multiSelect("deselect_all");
    // },

    // demoSelectAllClick() {
    //   $("#demoControl").multiSelect("select_all");
    // },

    // questSelectAllClick() {
    //   $("#questControl").multiSelect("select_all");
    // },

    // questDeselectAllClick() {
    //   $("#questControl").multiSelect("deselect_all");
    // },
    async OnlyNameUpdateAxios(
      Url,
      VisitTypeName //1
    ) {
      //debugger;
      this.intDummyComm();
      const loader = this.$loading.show({
        color: "#03a9f3",
      });
      this.dummyComm.extras = VisitTypeName;
      this.dummyComm.extras1 = this.singleVTL.vt.visitTypeId;
      await axios({
        method: "post",
        url: Url,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          var check = res.data.auditFlag;
          if (check == 1) {
            createToast("Successfully Updated", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            this.visitTypeList.vtftl[
              this.VisitTypeActiveIndex
            ].vt.name = this.vtlName;
          } else {
            createToast(res.data.auditFlagVal, {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          loader.hide();
        });
    },
    updateVisitReasonsClick() {
      //$("#addNewRsn_btn1").prop("disabled", false);

      var check = this.prepareSingleVTDT();
      if (check == -1) {
        return;
      }
      this.updateVisitTypeClick();
    },
    async updateVisitTypDetailReasonsClick() {
     //debugger
      if (this.reasonIndex == -1) {
        //call name Api
        var url = this.SERVER + "/VNSPRAAPI/Reasons/ChangeVisitNameOnly";
        var VisitTypeName = this.vtlName;

        await this.OnlyNameUpdateAxios(url, VisitTypeName);
        return;
      }
      const obj = await this.prepareSingleVisitTypeDetail();
      await this.UpdateVisitTypeDetailData(obj);
    },
    async UpdateVisitTypeDetailData(obj) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Reasons/UpdateVisitTypeDetail",
        data: obj,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          this.dummyComm = res.data;
          console.log(this.dummyComm.auditFlag);
          if (this.dummyComm.auditFlag < 0) {
            createToast(this.dummyComm.auditFlagVal, {
              type: "danger",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
          } else {
            createToast("Information Updated", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            //this.indexValue= null;
            this.loadInit();
            $("#UpdVtype_btn").prop("disabled", false);
            $("#UpdVst_btn").prop("disabled", false);
          }
        })
        .catch(function(error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => {
          $("#UpdVst_btn").prop("disabled", false);
          this.ResetLogoutTime();
          this.dataChanged = false;
          if (loader != null) loader.hide();
        });
    },
    prepareSingleVTDT() {
      //debugger;
      if (this.reasonIndex == -1) {
        //call name Api
        var url = this.SERVER + "/VNSPRAAPI/Reasons/ChangeVisitNameOnly";
        var VisitTypeName = this.vtlName;

        this.OnlyNameUpdateAxios(url, VisitTypeName);
        return -1;
      }
     //debugger
      let obj = this.singleVTL.vtdt[this.reasonIndex];

      obj.vtd.reason = this.reasonName;
      obj.vtd.physicianId = this.physicianId;
      obj.demoList = [];
      obj.questList = [];
      obj.smsList = [];
      obj.emailList = [];
      obj.tasks = this.taskSelected;
      obj.questIsRequired = [];
      //debugger; // eslint-disable-line no-//debugger

      // sms
      let x = this.smsSelected.length;
      for (let i = 0; i < x; i++) {
        obj.smsList.push({});
        obj.smsList[i].seId = this.smsSelected[i].smsId;
        obj.smsList[i].srNo = i + 1;
      }
      // email
      x = this.emailSelected.length;
      for (let i = 0; i < x; i++) {
        obj.emailList.push({});
        obj.emailList[i].seId = this.emailSelected[i].emailId;
        obj.emailList[i].srNo = i + 1;
      }
      // Quests
      console.log("QUESTS: ", this.selectedQuests);
      x = this.selectedQuests.length;
      for (let i = 0; i < x; i++) {
        obj.questList.push({});
        //obj.questList[i].questId = this.quests[this.selectedQuests[i]].questId;
        obj.questList[i].questId = this.selectedQuests[i].questId;
        if (
          this.selectedQuests[i].isRequired === true ||
          this.selectedQuests[i].isRequired === "1"
        ) {
          obj.questList[i].isRequired = "1";
        } else {
          obj.questList[i].isRequired = "0";
        }
       //debugger
        obj.questList[i].srNo = this.quests.find(
          (x) => x.questId == obj.questList[i].questId
        ).srNo;
        //obj.questList[i].srNo = i + 1;
      }

      // Demos
      //
      x = this.selectedDemos.length;
      for (let i = 0; i < x; i++) {
        obj.demoList.push({});
        //obj.demoList[i].questId = this.demos[this.selectedDemos[i]].demoId;
        obj.demoList[i].questId = this.selectedDemos[i].questId;
        if (
          this.selectedDemos[i].isRequired === true ||
          this.selectedDemos[i].isRequired === "1"
        ) {
          obj.demoList[i].isRequired = "1";
          this.selectedDemos[i].isRequired = "1";
        } else {
          obj.demoList[i].isRequired = "0";
          this.selectedDemos[i].isRequired = "0";
        }

        obj.demoList[i].srNo = i + 1;
      }

      return 1;
    }, //prepareSingleVTDT
    async prepareSingleVisitTypeDetail() {
      this.intDummyComm();
      let smsList = [];
      let emailList = [];
      let questList = [];
      let demoList = [];
      let tasks = this.taskSelected; // tasks is all good
      let VisitTypeDetailSrno = [];   
      for (let i = 0; i < this.singleVTL.vtdt.length; i++) {
        let obj = {
        SrNo: this.singleVTL.vtdt[i].vtd.srNo+1,
        VisitDetailId: this.singleVTL.vtdt[i].vtd.visitDetailId
        }
        VisitTypeDetailSrno.push(obj);
      }
      this.visitTypeDetailSrno = VisitTypeDetailSrno;
        
      //Sms Selected
      for (let i = 0; i < this.smsSelected.length; i++) {
        smsList.push({});
        smsList[i].seId = this.smsSelected[i].smsId;
        smsList[i].srNo = i + 1;
      }
      //email Selected
      for (let i = 0; i < this.emailSelected.length; i++) {
        emailList.push({});
        emailList[i].seId = this.emailSelected[i].emailId;
        emailList[i].srNo = i + 1;
      }

      console.log("QUESTS: ", this.selectedQuests);
      for (let i = 0; i < this.selectedQuests.length; i++) {
        questList.push({});
        //obj.questList[i].questId = this.quests[this.selectedQuests[i]].questId;
        questList[i].questId = this.selectedQuests[i].questId;
        if (
          this.selectedQuests[i].isRequired === true ||
          this.selectedQuests[i].isRequired === "1"
        ) {
          questList[i].isRequired = "1";
        } else {
          questList[i].isRequired = "0";
        }
       //debugger
        questList[i].srNo = this.quests.find(
          (x) => x.questId == questList[i].questId
        ).srNo;
      }
      this.selectedDemos = this.selectedDemos.sort((a, b) =>
        a.srNo > b.srNo ? 1 : b.srNo > a.srNo ? -1 : 0
      );
      for (let i = 0; i < this.selectedDemos.length; i++) {
        demoList.push({});
        demoList[i].questId = this.selectedDemos[i].questId;
        if (
          this.selectedDemos[i].isRequired === true ||
          this.selectedDemos[i].isRequired === "1"
        ) {
          demoList[i].isRequired = "1";
          this.selectedDemos[i].isRequired = "1";
        } else {
          demoList[i].isRequired = "0";
          this.selectedDemos[i].isRequired = "0";
        }
        demoList[i].srNo = i + 1;
      }
     //debugger
      this.dummyComm.visitDetailId = this.activeVisitReason.vtd.visitDetailId;
      this.dummyComm.visitTypeId = this.activeVisitReason.vtd.visitTypeId;
      let obj = {
        VisitDetailId: this.activeVisitReason.vtd.visitDetailId,
        VisitTypeId: this.activeVisitReason.vtd.visitTypeId,
        DC: this.dummyComm,
        Reason: this.reasonName,
        PhysicianId: this.physicianId,
        SrNo: this.activeVisitReason.vtd.srNo,
        IsDeleted: 0,
        SelectedSmsList: smsList,
        SelectedEmailList: emailList,
        SelectedQuestList: questList,
        SelectedDemoList: demoList,
        SelectedTasks: tasks,
        VisitTypeDetailSrno :this.visitTypeDetailSrno,
      };
      return obj;
    },

    updateVisitTypeClick() {
     //debugger
      if (this.reasonName == "") {
        this.display1 = true;
        return;
      }
      if (this.visitTypeIndex < 0) return;
      else {
        for (let i = 0; i < this.singleVTL.vtdt.length; i++)
          this.singleVTL.vtdt[i].vtd.srNo = i + 1;
        this.intDummyComm();
        this.dummyComm.extras = this.visitTypeIndex + this.UKEY;
        this.dummyComm.visitDetailId = this.visitDetailId;

        $("#UpdVtype_btn").prop("disabled", true);
        $("#UpdVst_btn").prop("disabled", true);

        //debugger; // eslint-disable-line no-//debugger

        let vt = [{}];
        vt.push(this.singleVTL);
        let myData = {
          dc: this.dummyComm,
          vtftl: vt,
        };

        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
        axios({
          method: "post",
          url: this.SERVER + "/VNSPRAAPI/Reasons/UpdateVisitType",
          data: myData,
           headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
        })
          .then((res) => {
            loader.hide();
            this.dummyComm = res.data;
            console.log(this.dummyComm.auditFlag);
            if (this.dummyComm.auditFlag < 0) {
              createToast(this.dummyComm.auditFlagVal, {
                type: "danger",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
            } else {
              createToast("Information Updated", {
                type: "success",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
              //this.indexValue= null;
              this.loadInit();
              $("#UpdVtype_btn").prop("disabled", false);
              $("#UpdVst_btn").prop("disabled", false);
            }
          })
          .catch(function(error) {
            if (error.response) {
              alert("-> " + error.response.data);
              alert("-> " + error.response.status);
              alert("-> " + error.response.headers);
            } else if (error.request) {
              alert("No response " + error.request);
            }
          })
          .finally(() => {
            $("#UpdVst_btn").prop("disabled", false);
            this.ResetLogoutTime();
            this.dataChanged = false;
            loader.hide();
          });
      }
    }, // updateVisitTypeClick

    updateVisitTypeClick_1() {
      if (this.vtlName == "") {
        this.ShowWarning("Visit Type name is require");
        return;
      }

      if (this.visitTypeIndex < 0) return;
      else {
        this.intDummyComm();
        this.dummyComm.extras = this.visitTypeIndex + this.UKEY;
        this.dummyComm.visitDetailId = 0;

        $("#UpdVtype_btn").prop("disabled", true);
        $("#UpdVst_btn").prop("disabled", true);

        let vt = [{}];
        vt.push(this.singleVTL.vt);
        let myData = {
          dc: this.dummyComm,
          VT: vt[1],
        };

        var loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
        axios({
          method: "post",
          url: this.SERVER + "/VNSPRAAPI/Reasons/UPDVSTTYP1",
          data: myData,
           headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
        })
          .then((res) => {
            loader.hide();
            this.dummyComm = res.data;
            console.log(this.dummyComm.auditFlag);
            if (this.dummyComm.auditFlag < 0) {
              createToast(this.dummyComm.auditFlagVal, {
                type: "danger",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
            } else {
              createToast("Information Updated", {
                type: "success",
                showIcon: "true",
                transition: "slide",
                timeout: 1500,
              });
              //this.indexValue= null;
              this.loadInit();
              $("#UpdVtype_btn").prop("disabled", false);
              $("#UpdVst_btn").prop("disabled", false);
            }
          })
          .catch(function(error) {
            if (error.response) {
              alert("-> " + error.response.data);
              alert("-> " + error.response.status);
              alert("-> " + error.response.headers);
            } else if (error.request) {
              alert("No response " + error.request);
            }
          })
          .finally(() => {
            this.ResetLogoutTime();
            loader.hide();
          });
      }
    }, // updateVisitTypeClick_1

    addNewReason() {
      //$("#addNewRsn_btn1").prop("disabled", true);
     
      let x = this.singleVTL.vtdt.length + 1;
      const vtdt = {
        demoList: [],
        emailList: [],
        questList: [],
        smsList: [],
        vtd: {
          isDeleted: 0,
          physicianId: 0,
          physicianName: "",
          reason: "Reason-" + x,
          srNo: x,
          visitDetailId: x,
          visitTypeId: this.visitTypeIndex,
        },
      };

      this.singleVTL.vtdt.push(vtdt);
      this.intDummyComm();
      this.dummyComm.extras = this.singleVTL.vt.visitTypeId;
      this.dummyComm.extras1 = "Reason-" + x;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/AddNewVisitTypeReason";
      this.dummyComm.pageNumber = this.pageNumberDemo;
      this.dummyComm.pageSize = this.pageSizeDemo;
      this.dummyComm.filter = this.filterDemo;

      var obj = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        filter: this.filter,
        dc: this.dummyComm,
      };
      this.axiosGetData(url, 99, obj);
    }, // addNewReason

    physicianSelected(id) {
      this.physicianId = id.target.value;
    }, // physicianSelected
    removeDuplications(questions, demosss) {
      //debugger; // eslint-disable-line no-//debugger
      var len = questions.length;
      for (var i = 0; i < len; i++) {
        for (var j = 0; j < len; j++)
          if (questions[i] === this.quests[j]) this.quests.splice();
      }

      len = demosss.length;
      for (var x = 0; x < len; x++) {
        for (var y = 0; y < this.demos.length; y++) {
          if (demosss[x] === this.demos[y]) {
            this.demos.splice();
            x = 0;
            break;
          }
        }
      }
    },
    visitReasonClick(obj, ndx, id) {
      if (this.dataChanged === true) {
        Swal.fire({
          title:
            "Current Changes will be lost. Either countinue or Please Save ",
          showDenyButton: true,
          confirmButtonText: "countinue",
          denyButtonText: `Stay`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.dataChanged = false;
            this.visitReasonClick(obj, ndx, id);
          } else if (result.isDenied) {
            $("#navlink" + id).removeClass("active");
            $("#navlink" + this.activeVisitReason.vtd.visitDetailId).addClass(
              "active"
            );
            return;
          }
        });
        return;
      }

      this.dataChanged = false;
      this.activeVisitReason = obj;
      this.visitData.isDeleted = obj.vtd.isDeleted;
      this.reasonIndex = ndx;
      this.physicianId = obj.vtd.physicianId;
      this.reasonName = obj.vtd.reason;
      this.visitDetailId = id;
      this.ResetRequiredDemoQuestOpt(0); //Jawad
      //this.selectedQuests = []; // These list save the Question
      //this.selectedDemos = []; //These list save the Demos

      //Quests
      //debugger;
      //usman111
      $('input[name="questsNameCB').prop("checked", false);
      for (let i = 0; i < this.quests.length; i++) {
        let x = this.quests[i].questId;
        for (let j = 0; j < obj.questList.length; j++) {
          let y = obj.questList[j].questId;
          if (x === y) {
            var myQuest = this.quests[i];
            $("#questsCB" + myQuest.questId).prop("checked", true);
            if (
              obj.questList[j].isRequired === "1" ||
              (obj.questList[j].isRequired === true &&
                this.visitDetailId === obj.questList[j].visitDetailId)
            ) {
              this.quests[i].isRequired = true;
            }
            break;
          }
        }
      }

      this.selectedQuests = obj.questList; //highest value so that it show at the end
      for (let x = 0; x < this.quests.length; x++) {
        this.quests[x].srNo = 9999;
        for (let y = 0; y < this.selectedQuests.length; y++) {
          if (this.quests[x].questId == this.selectedQuests[y].questId) {
            this.quests[x].srNo = this.selectedQuests[y].srNo;
            break;
          }
        }
      }

      this.quests = this.quests.sort((a, b) =>
        a.srNo > b.srNo ? 1 : b.srNo > a.srNo ? -1 : 0
      );
      //only for older practices used age
     //debugger
      for (let x = 0; x < this.quests.length; x++) {
        if (this.quests[x].srNo >= 0 && this.quests[x].srNo !== 9999) {
          if (this.quests[x].srNo !== x + 1) {
            this.quests[x].srNo = x + 1;
          }
        }
      }
      // Back end sends string
      this.checkButtons();
      //set demos for
      //debugger;
      $('input[name="demosNameCB"]').prop("checked", false);
      const testDemos = this.demos; //page demos
      for (let a = 0; a < testDemos.length; a++) {
        let x = this.demos[a].demoId;
        for (let b = 0; b < obj.selectedDemos.length; b++) {
          let y = obj.selectedDemos[b].questId;
          if (x === y && obj.selectedDemos[b].visitDetailId === id) {
            var myDemo = this.demos[a];
            $("#demosCB" + myDemo.demoId).prop("checked", true);
            if (
              obj.selectedDemos[b].isRequired === "1" ||
              obj.selectedDemos[b].isRequired === true
            ) {
              this.demos[a].isRequired = true;
            }
            break;
          }
        }
      }

      this.selectedDemos = obj.selectedDemos; //
      this.demos = this.demos.map((de, i) => {
        de.srNo = i + 1;
        de.Checked =
          this.selectedDemos.find((x) => x.questId == de.demoId) != undefined
            ? true
            : false;
        return de;
      });
      console.log("Sorted", this.demos);
      var nonsort = this.demos.filter((e) => e.srNo < 19);
      var sorts = this.demos.filter((e) => e.srNo > 18);
      sorts = sorts.sort((a, b) =>
        Number(
          a.Checked != undefined
            ? a.Checked
            : this.selectedDemos.find((x) => x.questId == a.demoId) != undefined
            ? true
            : false
        ) >
        Number(
          b.Checked != undefined
            ? b.Checked
            : this.selectedDemos.find((x) => x.questId == b.demoId) != undefined
            ? true
            : false
        )
          ? -1
          : 1
      );
      console.log("Sorted", sorts);
      this.demos = nonsort.concat(sorts);
      this.smsSelected = [];
      for (let i = 0; i < obj.smsList.length; i++) {
        let y = obj.smsList[i].seId;
        let z = obj.smsList[i].name;
        for (let j = 0; j < this.smsList1.length; j++) {
          let x = this.smsList1[j].smsId;
          if (x == y) {
            var obj1 = {
              smsId: y + "",
              smsName: z,
            };
            this.smsSelected.push(obj1);
            break;
          }
        }
      }

      this.emailSelected = [];
      for (let i = 0; i < obj.emailList.length; i++) {
        let y = obj.emailList[i].seId;
        let z = obj.emailList[i].name;
        for (let j = 0; j < this.emailList1.length; j++) {
          let x = this.emailList1[j].emailId;
          if (x == y) {
            var obj2 = {
              emailId: y + "",
              emailName: z,
            };
            this.emailSelected.push(obj2);
            break;
          }
        }
      }
      this.taskSelected = [];
      for (let i = 0; i < obj.tasks.length; i++) {
        let y = obj.tasks[i].value;
        for (let j = 0; j < this.taskOptions.length; j++) {
          let x = this.taskOptions[j].value;
          if (x == y) {
            this.taskSelected.push(this.taskOptions[j]);
            break;
          }
        }
      }
    },
    async GetVisitReason(obj, ndx, id) {
      this.intDummyComm();
      this.reasonIndex = ndx;
      if (this.dataChanged === true) {
        Swal.fire({
          title:
            "Current Changes will be lost. Either countinue or Please Save ",
          showDenyButton: true,
          confirmButtonText: "countinue",
          denyButtonText: `Stay`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.dataChanged = false;
            this.visitReasonClick(obj, ndx, id);
          } else if (result.isDenied) {
            $("#navlink" + id).removeClass("active");
            $("#navlink" + this.activeVisitReason.vtd.visitDetailId).addClass(
              "active"
            );
            return;
          }
        });
        return;
      }
      var MyUrl = this.SERVER + "/VNSPRAAPI/Reasons/GetSingleVisitTypeReason";
      this.dummyComm.visitDetailId = id;
      this.dummyComm.visitTypeID = obj.vtd.visitTypeId;
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: MyUrl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
         //debugger
          this.activeVisitReason = obj;
          // if everything goes well -- we will get data
          var ResObj = res.data;
          debugger;
          this.visitData.isDeleted =this.activeVisitReason.vtd.isDeleted;
          this.physicianId = ResObj.physicianId;
          this.reasonName = ResObj.reason;
          this.visitDetailId = ResObj.visitDetailId;
          this.ResetRequiredDemoQuestOpt(0); //Jawad
          //this.selectedQuests = []; // These list save the Question
          //this.selectedDemos = []; //These list save the Demos

          //Quests
          //debugger;
          //usman111
          $('input[name="questsNameCB').prop("checked", false);
          for (let i = 0; i < this.quests.length; i++) {
            let x = this.quests[i].questId;
            for (let j = 0; j < ResObj.selectedQuestList.length; j++) {
              let y = ResObj.selectedQuestList[j].questId;
              if (x === y) {
                var myQuest = this.quests[i];
                $("#questsCB" + myQuest.questId).prop("checked", true);
                if (
                  ResObj.selectedQuestList[j].isRequired === "1" ||
                  (ResObj.selectedQuestList[j].isRequired === true &&
                    this.visitDetailId === ResObj.questList[j].visitDetailId)
                ) {
                  this.quests[i].isRequired = true;
                }
                break;
              }
            }
          }
          
          this.selectedQuests = ResObj.selectedQuestList; //highest value so that it show at the end
          for (let x = 0; x < this.quests.length; x++) {
            this.quests[x].srNo = 9999;
            for (let y = 0; y < this.selectedQuests.length; y++) {
              if (this.quests[x].questId == this.selectedQuests[y].questId) {
                this.quests[x].srNo = this.selectedQuests[y].srNo;
                break;
              }
            }
          }

          this.quests = this.quests.sort((a, b) =>
            a.srNo > b.srNo ? 1 : b.srNo > a.srNo ? -1 : 0
          );
          //only for older practices used age
         //debugger
          for (let x = 0; x < this.quests.length; x++) {
            if (this.quests[x].srNo >= 0 && this.quests[x].srNo !== 9999) {
              if (this.quests[x].srNo !== x + 1) {
                this.quests[x].srNo = x + 1;
              }
            }
          }
          // Back end sends string
          this.checkButtons();
          //demo list
          $('input[name="demosNameCB"]').prop("checked", false);
          const testDemos = this.demos; //page demos
          for (let a = 0; a < testDemos.length; a++) {
            let x = this.demos[a].demoId;
            for (let b = 0; b < ResObj.selectedDemoList.length; b++) {
              let y = ResObj.selectedDemoList[b].questId;
              if (x === y && ResObj.selectedDemoList[b].visitDetailId === id) {
                var myDemo = this.demos[a];
                $("#demosCB" + myDemo.demoId).prop("checked", true);
                if (
                  ResObj.selectedDemoList[b].isRequired === "1" ||
                  ResObj.selectedDemoList[b].isRequired === true
                ) {
                  this.demos[a].isRequired = true;
                }
                break;
              }
            }
          }

          this.selectedDemos = ResObj.selectedDemoList; //
          this.demos = this.demos.map((de, i) => {
            de.srNo = i + 1;
            de.Checked =
              this.selectedDemos.find((x) => x.questId == de.demoId) !=
              undefined
                ? true
                : false;
            return de;
          });
   
          console.log("Sorted", this.demos);
          var nonsort = this.demos.filter((e) => e.srNo < 19);
          var sorts = this.demos.filter((e) => e.srNo > 18);
          sorts = sorts.sort((a, b) =>
            Number(
              a.Checked != undefined
                ? a.Checked
                : this.selectedDemos.find((x) => x.questId == a.demoId) !=
                  undefined
                ? true
                : false
            ) >
            Number(
              b.Checked != undefined
                ? b.Checked
                : this.selectedDemos.find((x) => x.questId == b.demoId) !=
                  undefined
                ? true
                : false
            )
              ? -1
              : 1
          );
          debugger;
          for(let i = 0;i< sorts.length ;i++)
          {
            debugger;
            var changeSrno =  this.selectedDemos.find((x) => x.questId == sorts[i].demoId); 
            if(changeSrno!==undefined)
            {
                sorts[i].srNo= changeSrno.srNo;
            }
          }
          sorts=sorts.sort((a,b)=> a.srNo - b.srNo);
          this.demos = nonsort.concat(sorts);

          this.smsSelected = [];
          for (let i = 0; i < ResObj.selectedSmsList.length; i++) {
            let y = ResObj.selectedSmsList[i].seId;
            let z = ResObj.selectedSmsList[i].name;
            for (let j = 0; j < this.smsList1.length; j++) {
              let x = this.smsList1[j].smsId;
              if (x == y) {
                var obj1 = {
                  smsId: y + "",
                  smsName: z,
                };
                this.smsSelected.push(obj1);
                break;
              }
            }
          }

          this.emailSelected = [];
          for (let i = 0; i < ResObj.selectedEmailList.length; i++) {
            let y = ResObj.selectedEmailList[i].seId;
            let z = ResObj.selectedEmailList[i].name;
            for (let j = 0; j < this.emailList1.length; j++) {
              let x = this.emailList1[j].emailId;
              if (x == y) {
                var obj2 = {
                  emailId: y + "",
                  emailName: z,
                };
                this.emailSelected.push(obj2);
                break;
              }
            }
          }
          //set Tasks
          this.taskSelected = [];
          for (let i = 0; i < ResObj.selectedTasks.length; i++) {
            let y = ResObj.selectedTasks[i].value;
            for (let j = 0; j < this.taskOptions.length; j++) {
              let x = this.taskOptions[j].value;
              if (x == y) {
                this.taskSelected.push(this.taskOptions[j]);
                break;
              }
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          this.ResetLogoutTime();
          if (loader !== undefined || loader !== null) loader.hide();
        });
    },
    changeReasonActiveVal() {
      this.reasonIndex = -1;
    },
    ResetRequiredDemoQuestOpt(check) {
      //debugger; console.log("");
      if (check === 1) {
        for (let i = 0; i < this.demos.length; i++) {
          this.demos[i].isRequired = false;
        }
      } else if (check === 2) {
        for (let i = 0; i < this.quests.length; i++) {
          this.quests[i].isRequired = false;
        }
      } else {
        for (let i = 0; i < this.demos.length; i++) {
          this.demos[i].isRequired = false;
        }
        for (let i = 0; i < this.quests.length; i++) {
          this.quests[i].isRequired = false;
        }
      }
    },
    VisitReasonChooseSet() {
      // call this after page change api is called to set choose;
      //debugger;
      $('input[name="demosNameCB"]').prop("checked", false);
      for (let a = 0; a < this.selectedDemos.length; a++) {
        if (this.selectedDemos[a].visitDetailId == this.visitDetailId) {
          $("#demosCB" + this.selectedDemos[a].questId).prop("checked", true);
        }
      }
    },
    VisitReasonChooseSetQuest() {
      //debugger;
      $('input[name="questsNameCB"]').prop("checked", false);
      for (let a = 0; a < this.selectedQuests.length; a++) {
        if (this.selectedQuests[a].visitDetailId == this.visitDetailId) {
          $("#questsCB" + this.selectedQuests[a].questId).prop("checked", true);
        }
      }
    },
    async ReasonSrnoChange(obj)
    {
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Reasons/ReasonSrno",
        data: obj,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          
          const result = res.data;
          if (result.status) {
            console.log("ok");
          }
        })
        .catch(function (error) {
          alert(console.log(error));
        })
        .finally(() => {
          this.loadInitWithOutLoad();
          this.ResetLogoutTime();
        });
    },
    clickInnerUpButton(id) {
      //usman
     //debugger
      if (id > 0) {
        [this.singleVTL.vtdt[id - 1], this.singleVTL.vtdt[id]] = [
          this.singleVTL.vtdt[id],
          this.singleVTL.vtdt[id - 1],
        ];
        for (let i = 0; i < this.singleVTL.vtdt.length; i++) {
          this.singleVTL.vtdt[i].vtd.srNo = i + 1;
        }
        this.reasonIndex = -1;
      
        const ReasonSrNoRequest=[{
          VisitDetailId:this.singleVTL.vtdt[id - 1].vtd.visitDetailId,
          SrNo: this.singleVTL.vtdt[id - 1].vtd.srNo,
        },{
          VisitDetailId:this.singleVTL.vtdt[id].vtd.visitDetailId,
          SrNo: this.singleVTL.vtdt[id].vtd.srNo,
        }];

        let obj =
        {
          Dc: this.dummyComm,
          VisitTypeDetailSrNos:ReasonSrNoRequest          
        }
        console.log(obj);
        this.ReasonSrnoChange(obj);
        window.location.hash = "#addStage";
      }
    },    
    clickInnerDownButton(id) {
      //usman
     debugger;
      
      if (this.singleVTL.vtdt.length - 1 > id) {
        [this.singleVTL.vtdt[id + 1], this.singleVTL.vtdt[id]] = [
          this.singleVTL.vtdt[id],
          this.singleVTL.vtdt[id + 1],
        ];        
        for (let i = 0; i < this.singleVTL.vtdt.length; i++) {
          this.singleVTL.vtdt[i].vtd.srNo = i +1;
        }
        this.reasonIndex = +1;
        
        const ReasonSrNoRequest=[{
          VisitDetailId:this.singleVTL.vtdt[id + 1].vtd.visitDetailId,
          SrNo: this.singleVTL.vtdt[id + 1].vtd.srNo,
        },{
          VisitDetailId:this.singleVTL.vtdt[id].vtd.visitDetailId,
          SrNo: this.singleVTL.vtdt[id].vtd.srNo,
        }];

        let obj =
        {
          Dc: this.dummyComm,
          VisitTypeDetailSrNos:ReasonSrNoRequest          
        }
        console.log(obj);
        this.ReasonSrnoChange(obj);
        window.location.hash = "#addStage";
      }
    },
    editClick(id, VisitTypeIndex) {
      this.dataChanged = false;
      this.pageNumberDemo = 1;
      this.pageSizeDemo = 50;
      this.pageNumber = 1;
      this.pageSize = 50;
      this.filterDemo = "";
      this.filter = "";
      this.totalRowsDemo = 0;
      this.totalRows = 0;
      this.totalRowsQcount = 0;
      this.totalRowsDcount = 0;
      this.displayThisComponent = true;
      $("#FirstSelect").click();
      this.VisitTypeActiveIndex = VisitTypeIndex;
      this.visitTypeIndex = id;
      this.intDummyComm();
      this.dummyComm.extras = id + this.UKEY;
      this.dummyComm.pageNumber = this.pageNumberDemo;
      this.dummyComm.pageSize = this.pageSizeDemo;
      this.dummyComm.filter = this.filterDemo;

      var obj = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        filter: this.filter,
        dc: this.dummyComm,
      };
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GetVisitTypeSingleInfo";
      this.singleVTL = "";
      this.axiosGetData(url, 2, obj);
      if (id === -100) {
        this.singleVTL = "";
        let x = this.visitTypeList.vtftl.length - 1;
        this.singleVTL = JSON.stringify(this.visitTypeList.vtftl[x]);
        this.vtlName = this.singleVTL.vt.name;
        //$("#addStage").modal("show");
       
      }
    },
    deleteVisitTypeClick_2() {
      this.intDummyComm();
      this.dummyComm.extras = this.arcId1 + this.UKEY;
      this.dummyComm.visitDetailId = this.arcndx1;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/DLVTR";
      this.axiosGetData(url, 4, this.dummyComm);
      this.display4 = false;
    },
    ActiveReason() {
      this.intDummyComm();
      this.dummyComm.extras = this.arcId11 + this.UKEY;
      this.dummyComm.visitDetailId = this.arcndx11;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/DLVTRA";
      this.axiosGetData(url, 5, this.dummyComm);
      this.display5 = false;
    },
    showDemo(vtdt) {
      return vtdt.demoList.length < 1 ? "" : vtdt.demoList[0].questName;
    },
    showQuest(vtdt) {
      return vtdt.questList.length < 1 ? "" : vtdt.questList[0].questName;
    },
    showSms(vtdt) {
      return vtdt.smsList.length < 1 ? "" : vtdt.smsList[0].name;
    },
    showEmail(vtdt) {
      return vtdt.emailList.length < 1 ? "" : vtdt.emailList[0].name;
    },

    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },
    async SearchDataTable() {
      this.pageNumber = 1;
      this.tableLoaderQuest = true;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTVSTTYPQuesDATA";
      this.axiosGetQuestData(url);
    },
    pageChange(obj) {
      ////debugger;
      this.ResetRequiredDemoQuestOpt(2);
      this.tableLoaderQuest = true;
      if (obj == "Next") {
        ////debugger;
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTVSTTYPQuesDATA";
      this.axiosGetQuestData(url);
    },
    async axiosGetQuestData(Url) {
      //debugger;
      this.dummyComm.pageNumber = this.pageNumberDemo;
      this.dummyComm.pageSize = this.pageSizeDemo;
      this.dummyComm.filter = this.filterDemo;

      var objques = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        filter: this.filter,
        dc: this.dummyComm,
      };
      await axios({
        method: "post",
        url: Url,
        data: objques,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          //debugger;
          this.tableLoaderQuest = false;
          this.quests = res.data.output;
          this.totalPages = res.data.totalPagesQuest;
          this.pageSize = res.data.pageSizeQuest;
          this.totalRows = res.data.totalRow;
          this.totalRowsQcount = res.data.output.length;
          this.pageNumber = res.data.pageNumberQuest;
          //set required quest
          // for (var i = 0; i < this.quests.length; i++) {
          //   for (var j = 0; j < this.selectedQuests.length; j++) {
          //     if (this.quests[i].questId == this.selectedQuests[j].questId) {
          //       this.quests[i].isRequired = this.selectedQuests[j].isRequired;
          //       break;
          //     }
          //   }
          // }
          for (var i = 0; i < this.quests.length; i++) {
            for (var j = 0; j < this.selectedQuests.length; j++) {
              if (
                this.quests[i].questId == this.selectedQuests[j].questId &&
                this.visitDetailId == this.selectedQuests[j].visitDetailId
              ) {
                if (
                  this.selectedQuests[j].isRequired === "1" ||
                  this.selectedQuests[j].isRequired === true
                ) {
                  this.quests[i].isRequired = true;
                  break;
                }
              }
            }
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          this.tableLoaderQuest = false;
          this.VisitReasonChooseSetQuest();
        });
    },
    orderBy(column) {
      ////debugger;
      if (this.firstTime == true) {
        this.firstTime = false;
        return;
      }
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.quests = this.quests.sort((a, b) =>
            a.questId < b.questId ? 1 : b.questId < a.questId ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.quests = this.quests.sort((a, b) =>
            a.questId > b.questId ? 1 : b.questId > a.questId ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.quests = this.quests.sort((a, b) =>
            a.isRequired < b.isRequired
              ? 1
              : b.isRequired < a.isRequired
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.quests = this.quests.sort((a, b) =>
            a.isRequired > b.isRequired
              ? 1
              : b.isRequired > a.isRequired
              ? -1
              : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.quests = this.quests.sort((a, b) =>
            a.question < b.question ? 1 : b.question < a.question ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.quests = this.quests.sort((a, b) =>
            a.question > b.question ? 1 : b.question > a.question ? -1 : 0
          );
        }
      }
    },
    orderByRemeber(column) {
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.quests = this.quests.sort((a, b) =>
            a.questId < b.questId ? 1 : b.questId < a.questId ? -1 : 0
          );
        } else {
          this.quests = this.quests.sort((a, b) =>
            a.questId > b.questId ? 1 : b.questId > a.questId ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.quests = this.quests.sort((a, b) =>
            a.isRequired < b.isRequired
              ? 1
              : b.isRequired < a.isRequired
              ? -1
              : 0
          );
        } else {
          this.quests = this.quests.sort((a, b) =>
            a.isRequired > b.isRequired
              ? 1
              : b.isRequired > a.isRequired
              ? -1
              : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.quests = this.quests.sort((a, b) =>
            a.question < b.question ? 1 : b.question < a.question ? -1 : 0
          );
        } else {
          this.quests = this.quests.sort((a, b) =>
            a.question > b.question ? 1 : b.question > a.question ? -1 : 0
          );
        }
      }
    },

    async SearchDataTable1() {
      this.pageNumberDemo = 1;

      this.tableLoaderDemo = true;
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTVSTTYPDemosDATA";
      this.axiosGetDemoData(url);
    },

    pageChange1(obj) {
      //debugger;
      this.tableLoaderDemo = true;
      this.ResetRequiredDemoQuestOpt(1);
      if (obj == "Next") {
        ////debugger;
        if (this.pageNumberDemo < this.totalPagesDemo) {
          this.pageNumberDemo += 1;
        }
      } else if (obj == "Previous" && this.pageNumberDemo != 1) {
        this.pageNumberDemo -= 1;
      } else {
        this.pageNumberDemo = obj;
      }
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GTVSTTYPDemosDATA";
      this.axiosGetDemoData(url);
    },
    async axiosGetDemoData(Url) {
      //debugger;
      this.dummyComm.pageNumber = this.pageNumberDemo;
      this.dummyComm.pageSize = this.pageSizeDemo;
      this.dummyComm.filter = this.filterDemo;

      var objdemo = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        filter: this.dummyComm.filter,
        dc: this.dummyComm,
      };
      await axios({
        method: "post",
        url: Url,
        data: objdemo,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          //debugger;
          this.tableLoaderDemo = false;
          this.demos = res.data.output;
          this.totalPagesDemo = res.data.totalPagesDemo;
          this.pageSizeDemo = res.data.pageSizeDemo;
          this.totalRowsDemo = res.data.totalRowDemo;
          this.totalRowsDcount = res.data.output.length;
          this.pageNumberDemo = res.data.pageNumberDemo;

          for (var i = 0; i < this.demos.length; i++) {
            for (var j = 0; j < this.selectedDemos.length; j++) {
              if (
                this.demos[i].demoId == this.selectedDemos[j].questId &&
                this.visitDetailId == this.selectedDemos[j].visitDetailId
              ) {
                if (
                  this.selectedDemos[j].isRequired === "1" ||
                  this.selectedDemos[j].isRequired === true
                ) {
                  this.demos[i].isRequired = true;
                  break;
                }
              }
            }
          }

          // for (let i = 0; i < this.selectedDemos.length; i++) {

          /****************************************** 
            if demos exist in select demolist then add update checkbox
            demosCB' + demo.demoId ids of the items
            */
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          console.log("jkdzkjjksdfjksdkljsdkjlsdfkjsdfkjl");
          this.tableLoaderDemo = false;
          this.VisitReasonChooseSet();
        });
    },
    orderBy1(column) {
      ////debugger;
      if (this.firstTime == true) {
        this.firstTime = false;
        return;
      }
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.demos = this.demos.sort((a, b) =>
            a.demoId < b.demoId ? 1 : b.demoId < a.demoId ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.demos = this.demos.sort((a, b) =>
            a.demoId > b.demoId ? 1 : b.demoId > a.demoId ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.demos = this.demos.sort((a, b) =>
            a.isRequired < b.isRequired
              ? 1
              : b.isRequired < a.isRequired
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.demos = this.demos.sort((a, b) =>
            a.isRequired > b.isRequired
              ? 1
              : b.isRequired > a.isRequired
              ? -1
              : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.demos = this.demos.sort((a, b) =>
            a.demoName < b.demoName ? 1 : b.demoName < a.demoName ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.demos = this.demos.sort((a, b) =>
            a.demoName > b.demoName ? 1 : b.demoName > a.demoName ? -1 : 0
          );
        }
      }
    },
    orderByRemeber1(column) {
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.demos = this.demos.sort((a, b) =>
            a.demoId < b.demoId ? 1 : b.demoId < a.demoId ? -1 : 0
          );
        } else {
          this.demos = this.demos.sort((a, b) =>
            a.demoId > b.demoId ? 1 : b.demoId > a.demoId ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.demos = this.demos.sort((a, b) =>
            a.isRequired < b.isRequired
              ? 1
              : b.isRequired < a.isRequired
              ? -1
              : 0
          );
        } else {
          this.demos = this.demos.sort((a, b) =>
            a.isRequired > b.isRequired
              ? 1
              : b.isRequired > a.isRequired
              ? -1
              : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.demos = this.demos.sort((a, b) =>
            a.demoName < b.demoName ? 1 : b.demoName < a.demoName ? -1 : 0
          );
        } else {
          this.demos = this.demos.sort((a, b) =>
            a.demoName > b.demoName ? 1 : b.demoName > a.demoName ? -1 : 0
          );
        }
      }
    },

    loadInit() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GetVisitTypeTree";

      this.dummyComm.pageNumber = this.pageNumberDemo;
      this.dummyComm.pageSize = this.pageSizeDemo;
      this.dummyComm.filter = this.filterDemo;

      var obj = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        filter: this.filter,
        dc: this.dummyComm,
      };
      this.axiosGetData(url, 1, obj,0);
      this.StartLogoutTime();
    },
     loadInitWithOutLoad() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Reasons/GetVisitTypeTree";

      this.dummyComm.pageNumber = this.pageNumberDemo;
      this.dummyComm.pageSize = this.pageSizeDemo;
      this.dummyComm.filter = this.filterDemo;

      var obj = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        filter: this.filter,
        dc: this.dummyComm,
      };
      this.axiosGetData(url, 1, obj,1);
      this.StartLogoutTime();
    },
    //Maintains the functionality of push questions into arrays
    //no longer used
    quesPushInSelectedList(ques) {
      //debugger; // eslint-disable-line no-//debugger
      //find q and pop it then push it in quest_2
      this.selectedQuests.push(ques);
      for (let i = 0; this.quests.length >= i; i++) {
        if (this.quests[i] === ques) {
          this.quests.splice(i, 1);
          break;
        }
      }
    },
    quesPushInSelectedId(ques) {
      //usman111
     debugger
      this.dataChanged = true;
      for (var i = 0; i < this.selectedQuests.length; i++) {
        if (
          this.selectedQuests[i].questId === ques.questId &&
          this.visitDetailId === this.selectedQuests[i].visitDetailId
        ) {//removed
          this.selectedQuests.splice(i, 1);
          ques.srNo = 9999;
          ques.isRequired = false;
          this.sortQuest();
          this.checkButtons();
          return;
        }
      }
      var checkDemo = this.selectedQuests.find(
        (x) => x.questId == ques.questId
      );
      ques.srNo = this.selectedQuests.length + 1;
      if (checkDemo === undefined) {
        const DemoNew = {
          cid: 0,
          isDeleted: 0,
          isDemo: 0,
          isRequired: "0",
          questId: ques.questId,
          srNo: ques.srNo,
          questName: ques.questName,
          visitDetailId: this.visitDetailId, // usmanbutt
        };
        this.selectedQuests.push(DemoNew);
        console.log(this.selectedQuests);
        this.sortQuest();
        this.checkButtons();
      }
    },
    async sortQuest() {
      this.quests = this.quests.sort((a, b) =>
        a.srNo > b.srNo ? 1 : b.srNo > a.srNo ? -1 : 0
      );
    },
    async QuestSrNoAssign() {
      this.quests = this.quests.map((x) => {
        x.srNo =
          this.selectedQuests.indexOf(
            this.selectedQuests.find((y) => y.questId == x.questId)
          ) != -1
            ? this.selectedQuests.indexOf(
                this.selectedQuests.find((y) => y.questId == x.questId)
              ) + 1
            : 9999;

        return x;
      });
    },
    checkButtons() {
      this.$nextTick(function() {
       //debugger
        const obj = this.activeVisitReason;
        $('input[name="questsNameCB').prop("checked", false);
        for (let i = 0; i < this.quests.length; i++) {
          let x = this.quests[i].questId;
          for (let j = 0; j < this.selectedQuests.length; j++) {
            let y = this.selectedQuests[j].questId;
            if (x === y) {
              var myQuest = this.quests[i];
              $("#questsCB" + myQuest.questId).prop("checked", true);
              break;
            }
          }
        }
      });
    },

    demosPushInSelectedId(demo) {
         debugger;
      console.log(demo);
      //this my Function
      this.dataChanged = true;
      for (var i = 0; i < this.selectedDemos.length; i++) {
        if (
          this.selectedDemos[i].questId === demo.demoId &&
          this.visitDetailId === this.selectedDemos[i].visitDetailId
        ) {
          this.selectedDemos.splice(i, 1);
          demo.isRequired = false;
          this.sortDemos();
          return;
        }
      }
      var checkDemo = this.selectedDemos.find((x) => x.demoId == demo.demoId);
      if (checkDemo === undefined) {
        const DemoNew = {
          cid: 0,
          isDeleted: 0,
          isDemo: 1,
          isRequired: "0",
          questId: demo.demoId,
          srNo: demo.srNo,
          questName: demo.demoName,
          visitDetailId: this.visitDetailId, //
        };
        this.selectedDemos.push(DemoNew);
      }
      this.demos = this.demos.map((de) => {
        de.Checked =
          this.selectedDemos.find((x) => x.questId == de.demoId) != undefined
            ? true
            : false;
        return de;
      });
      this.sortDemos();
    },
    async sortDemos() {
      var nonsort = this.demos.filter((e) => e.demoId <= 19);
      var sorts = this.demos.filter((e) => e.demoId > 19);
      debugger;
      sorts =  sorts.sort((a, b)=> a.srno < b.srno ? 1 : b.srno < a.srno ? -1 : 0);
      console.log(sorts);
      sorts = sorts.sort((a, b) =>
        Number(
          a.Checked != undefined
            ? a.Checked
            : this.selectedDemos.find((x) => x.questId == a.demoId) != undefined
            ? true
            : false
        ) >
        Number(
          b.Checked != undefined
            ? b.Checked
            : this.selectedDemos.find((x) => x.questId == b.demoId) != undefined
            ? true
            : false
        )
          ? -1
          : 1
      );      
             
      //usman101
      this.$nextTick(()=>{      
      for(let i = 0; i<=sorts.length;i++)
      {
        sorts[i].srNo = i+19;
      }
      });

      this.demos = nonsort.concat(sorts);
    },
    quesPushInOriginalList(ques) {
      this.quests.push(ques);
      //find q and pop it then push it in quest_2
      for (let i = 0; this.selectedQuests.length >= i; i++) {
        if (this.selectedQuests[i] === ques) {
          this.selectedQuests.splice(i, 1);
          break;
        }
      }
    },

    demoPushInSelectedList(demo) {
      //find q and pop it then push it in quest_2
      //

      this.selectedDemos.push(demo);
      for (let i = 0; this.demos.length >= i; i++) {
        if (this.demos[i] === demo) {
          this.demos.splice(i, 1);
          break;
        }
      }
    },
    demoPushInOriginalList(demo) {
      this.demos.push(demo);
      //find q and pop it then push it in quest_2
      for (let i = 0; this.selectedDemos.length >= i; i++) {
        if (this.selectedDemos[i] === demo) {
          this.selectedDemos.splice(i, 1);
          break;
        }
      }
    },
    QuestionDisableArrows(quest, ndx) {
      var q = this.selectedQuests.find((x) => x.questId == quest.questId);
      if (q == undefined) {
        return true;
      } else {
        return false;
      }
      // for (let i = 0; i < this.selectedQuests.length; i++) {
      //   let x = this.selectedQuests[i].questId;
      //   let y = quest.questId;
      //   if (x === y) {
      //     return true;
      //   } else {
      //     return false;
      //   }

      //   // if (ndx + 1 <= 18) {
      //   //   return true;
      //   // } else {
      //   //   return false;
      //   // }
      // }
    },
    DemoDisableArrows(demo, ndx) {
      var d = this.selectedDemos.find((x) => x.questId == demo.demoId);
      if (d == undefined) {
        return true;
      } else {
        return false;
      }
      // for (let i = 0; i < this.selectedDemos.length; i++) {
      //   let x = this.selectedDemos[i].questId;
      //   let y = demo.demoId;
      //   demo.srNo = ndx + 1;
      //   if (x === y) {
      //     return false;
      //   } else {
      //     return false;
      //   }
      // }

      // return true;
    },
    demoUpArrow(demo, ndx) {

      if (demo.srNo > 19) {
        this.demos = this.demos.map((e, i, a) => {
          if (e.srNo == ndx) {
            console.log(a[ndx]);
            console.log(a[ndx - 1]);
            let t = {
              demoId: e.demoId,
              demoName: e.demoName,
              isRequired: e.isRequired,
              output: e.output,
              pageNumberDemo: e.pageNumberDemo,
              pageSizeDemo: e.pageSizeDemo,
              srNo: ndx + 1,
              totalPagesDemo: e.totalPagesDemo,
              totalRowDemo: e.totalRowDemo,
            };
            let u = {
              demoId: demo.demoId,
              demoName: demo.demoName,
              isRequired: demo.isRequired,
              output: demo.output,
              pageNumberDemo: demo.pageNumberDemo,
              pageSizeDemo: demo.pageSizeDemo,
              srNo: ndx,
              totalPagesDemo: demo.totalPagesDemo,
              totalRowDemo: demo.totalRowDemo,
            };
            console.log(t);
            a[ndx] = t;
            a[ndx - 1] = u;
          }
          a[ndx].Checked =
            this.selectedDemos.find((x) => x.questId == a[ndx].demoId) !=
            undefined
              ? true
              : false;
          a[ndx - 1].Checked =
            this.selectedDemos.find((x) => x.questId == a[ndx - 1].demoId) !=
            undefined
              ? true
              : false;
          return a[i];
        });
      }
      debugger;
      var demo1 = this.selectedDemos.find((x) => x.questId == this.demos[ndx - 1].demoId);
      demo1.srNo = this.demos[ndx-1].srNo;
      var demo2 = this.selectedDemos.find((x) => x.questId == this.demos[ndx].demoId);
      demo2.srNo = this.demos[ndx].srNo;
      this.demos = this.demos.sort(
        (a, b) =>
          Number(a.Checked != undefined ? a.Checked : false) >
          Number(b.Checked != undefined ? b.Checked : false)
      );
    },
    lastDemoIsChecked()
    {     
      var lastDemo = null;
      this.demos.forEach((demo,index)=>{
        if(demo.Checked===true)
        {
          lastDemo = demo;
        }
      });
      return lastDemo;                  
    },
    demoDownArrow(demo, ndx) {      

      if (demo.srNo >= 19) {           
        var lastDemo = this.lastDemoIsChecked();
        if(lastDemo == null){ console.log("no demo Added");}
        else if(lastDemo.demoId == demo.demoId){ return; }
        var demos = this.demos.map((e, i, a) => {
          if (i == ndx + 1) {
            let t = {
              demoId: demo.demoId,
              demoName: demo.demoName,
              isRequired: demo.isRequired,
              output: demo.output,
              pageNumberDemo: demo.pageNumberDemo,
              pageSizeDemo: demo.pageSizeDemo,
              srNo: ndx + 2,
              totalPagesDemo: demo.totalPagesDemo,
              totalRowDemo: demo.totalRowDemo,
            };
            var u = {
              demoId: e.demoId,
              demoName: e.demoName,
              isRequired: e.isRequired,
              output: e.output,
              pageNumberDemo: e.pageNumberDemo,
              pageSizeDemo: e.pageSizeDemo,
              srNo: ndx + 1,
              totalPagesDemo: e.totalPagesDemo,
              totalRowDemo: e.totalRowDemo,
            };
            console.log(ndx);
            a[ndx] = u;
            a[i] = t;
          }
          a[ndx].Checked =
            this.selectedDemos.find((x) => x.questId == a[ndx].demoId) !=
            undefined
              ? true
              : false;
          a[i].Checked =
            this.selectedDemos.find((x) => x.questId == a[i].demoId) !=
            undefined
              ? true
              : false;
          return a[i];
        });
      }
      debugger;
      var demo1 = this.selectedDemos.find((x) => x.questId == this.demos[ndx + 1].demoId);
      demo1.srNo = this.demos[ndx+1].srNo;
      var demo2 = this.selectedDemos.find((x) => x.questId == this.demos[ndx].demoId);
      demo2.srNo = this.demos[ndx].srNo;
      // this.demos = demos.sort((a,b)=> a.srNo > b.srNo ? 1:-1);
    },
    QuestionUpArrow(quest, index) {
      if (quest.srNo !== 1) {
        this.quests[index - 1].srNo = quest.srNo;
        quest.srNo = quest.srNo - 1;

        // this.quests[index -1].srNo =this.quests[index +1].srNo+1;
      }
      this.quests = this.quests.sort((a, b) =>
        a.srNo > b.srNo ? 1 : b.srNo > a.srNo ? -1 : 0
      );
      const obj = this.activeVisitReason;
      console.log("this is obj");
      console.log(obj);
      $('input[name="questsNameCB').prop("checked", false);
     
        $('input[name="questsNameCB').prop("checked", false);
        for (let i = 0; i < this.quests.length; i++) {
          let x = this.quests[i].questId;
          for (let j = 0; j < this.selectedQuests.length; j++) {
            let y = this.selectedQuests[j].questId;
            if (x === y) {
              var myQuest = this.quests[i];
              $("#questsCB" + myQuest.questId).prop("checked", true);
              break;
            }
          }
        }
      // for (let i = 0; i < this.quests.length; i++) {
      //   let x = this.quests[i].questId;
      //   for (let j = 0; j < obj.questList.length; j++) {
      //     let y = obj.questList[j].questId;
      //     if (x === y) {
      //       var myQuest = this.quests[i];
      //       $("#questsCB" + myQuest.questId).prop("checked", true);
      //       break;
      //     }
      //   }
      // }
    
    },

    QuestionDownArrow(quest, index) {
      if (quest.srNo + 1 < this.selectedQuests.length + 1) {
        this.quests[index + 1].srNo = quest.srNo;
        quest.srNo = quest.srNo + 1;
        this.quests = this.quests.sort((a, b) =>
          a.srNo > b.srNo ? 1 : b.srNo > a.srNo ? -1 : 0
        );
        const obj = this.activeVisitReason;
        $('input[name="questsNameCB').prop("checked", false);
          for (let i = 0; i < this.quests.length; i++) {
          let x = this.quests[i].questId;
          for (let j = 0; j < this.selectedQuests.length; j++) {
            let y = this.selectedQuests[j].questId;
            if (x === y) {
              var myQuest = this.quests[i];
              $("#questsCB" + myQuest.questId).prop("checked", true);
              break;
            }
          }
        }
      }
    },
    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what, data, noload = 0) {
      debugger;
      var loader = null;
      if(noload==0)
      {
        
        loader = this.$loading.show({
          // Optional parameters
          color: "#03a9f3",
        });
      }
      
      await axios({
        method: "post",
        url: myUrl,
        data: data,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
          if (what === 1) {
            //debugger;
            // this.loader.hide();
            this.visitTypeList = res.data;
            // for(let i=0;i<this.visitTypeList.vtftl.length;i++){
            //   if(this.visitTypeList.vtftl[i].vt.visitTypeId == this.visitTypeIndex){
            //   this.singleVTL =  this.visitTypeList.vtftl[i];
            //   }
            // }
            for (let i = 0; i < res.data.vtftl.length; i++) {
              if (res.data.vtftl[i].vt.visitTypeId == this.visitTypeIndex) {
                this.singleVTL = res.data.vtftl[i];
              }
            }
          } else if (what === 99) {
            // console.log(res.data);
            // this.visitTypeList = res.data;
            // for(let i=0;i<this.visitTypeList.vtftl.length;i++){
            //   if(this.visitTypeList.vtftl[i].vt.visitTypeId == this.visitTypeIndex){
            //   this.singleVTL =  this.visitTypeList.vtftl[i];
            //   }
            // }
            for (let i = 0; i < res.data.vtftl.length; i++) {
              if (res.data.vtftl[i].vt.visitTypeId == this.visitTypeIndex) {
                this.singleVTL = res.data.vtftl[i];
              }
            }
          } else if (what === 2) {
            //-----------------
            //console.log(res.data.smss);
            //debugger; // eslint-disable-line no-//debugger
            this.emails = res.data.emails;
            this.phys = res.data.phys;
            this.smss = res.data.smss;
            this.mydata = res.data;
            this.taskOptions = res.data.tasks;
            this.quests = res.data.quests.output;
            this.totalPages = res.data.quests.totalPagesQuest;
            this.pageSize = res.data.quests.pageSizeQuest;
            this.totalRows = res.data.quests.totalRow;
            this.totalRowsQcount = res.data.quests.output.length;
            this.pageNumber = res.data.quests.pageNumberQuest;
            //debugger;
            this.demos = res.data.demos.output;
            this.totalPagesDemo = res.data.demos.totalPagesDemo;
            this.pageSizeDemo = res.data.demos.pageSizeDemo;
            this.totalRowsDemo = res.data.demos.totalRowDemo;
            this.totalRowsDcount = res.data.demos.output.length;
            this.pageNumberDemo = res.data.demos.pageNumberDemo;

            for (var i = 0; i < this.quests.length; i++) {
              if (this.quests[i].isRequired == "True") {
                this.quests[i].isRequired = true;
              } else {
                this.quests[i].isRequired = false;
              }
            }
            for (var j = 0; j < this.demos.length; j++) {
              if (this.demos[j].isRequired == "True") {
                this.demos[j].isRequired = true;
              } else {
                this.demos[j].isRequired = false;
              }
            }
            //filter PhysicianActive
            this.phys = this.phys.filter((i) => i.isPhysicianActive == true);
            console.log(this.phys);
            if (this.visitTypeIndex !== -100) {
              this.singleVTL = res.data.vtftl.vtftl[0];
              this.vtlName = this.singleVTL.vt.name;
              $("#addStage").modal("show");

             
            }
          } else if (what === 3) {
            //debugger;
            createToast("Successfully Removed", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            this.dummyComm = res.data;
            if (this.dummyComm.auditFlag > 0) {
              this.visitTypeList.vtftl.splice(this.visitTypeIndex, 1);
            }
          } else if (what === 4) {
            //debugger;
            createToast("Successfully Removed", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            this.dummyComm = res.data;
            if (this.dummyComm.auditFlag > 0) {
              this.visitTypeList.vtftl.splice(this.visitTypeIndex, 1);
            }
            $("#addStage").modal("hide");
            this.visitData.isDeleted = 1; //usman

            this.loadInit();
            // this.editClick(this.visitTypeIndex);
          } else if (what === 5) {
            createToast("Successfully Actived", {
              type: "success",
              showIcon: "true",
              transition: "slide",
              timeout: 1500,
            });
            this.dummyComm = res.data;
            $("#addStage").modal("hide");
            this.visitData.isDeleted = 0;
            this.loadInit();
          }
      
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
           $("#addNewStg_btn").prop("disabled", false);
            $("#addNewRsn_btn").prop("disabled", false);  
          try {
            debugger;
              loader.hide();
                    
          }
          catch(err) {
              console.log(err);
          }
          this.ResetLogoutTime();
          
        });
    }, // axiosGetData
    SmsDataChanged() {
      this.dataChanged = true;
    },
    EmailDataChanged() {
      this.dataChanged = true;
    },
    ReasonNameChange() {
      this.dataChanged = true;
    },
  }, // methods
  computed: {
    showType: function() {
      let xx = "";
      try {
        xx = this.singleVTL.vt.name;
      } catch {
        xx = "";
      }
      return xx;
    },
  }, // computed
  watch: {
    vtlName: function(val) {
      this.singleVTL.vt.name = val;
    },
    smss: function(val) {
      this.smsList1 = [];
      for (let i = 0; i < val.length; i++) {
        let obj = {
          smsId: val[i].smsId,
          smsName: val[i].smsName,
        };
        this.smsList1.push(obj);
      }
      for (let x = 0; x < this.smsList1.length; x++) {
        this.smsList1[x].smsId = this.smsList1[x].smsId + "";
      }
    },
    selectedDemos:function () 
    {
      this.$nextTick(() => {
        try {
          this.sortDemos();
        } catch {
          return -1;
        }
      }); 
      
    },

    emails: function(val) {
      this.emailList1 = [];
      for (let i = 0; i < val.length; i++) {
        let obj = {
          emailId: val[i].emailId,
          emailName: val[i].emailName,
        };
        this.emailList1.push(obj);
      }
      for (let x = 0; x < this.emailList1.length; x++) {
        this.emailList1[x].emailId = this.emailList1[x].emailId + "";
      }
    },
  },
  mounted() {
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  }, // mounted
  unmounted() {
    clearTimeout(this.TimerObject);
  },
};